import { isEmpty, cloneDeep } from 'lodash';

import { saveChangesInRPAPath } from '../../api/Missions/mission-methods-client';
import { getWaypointList } from '../../api/Missions/mission-operations';

import {
  insertNewWaypointsAtIndex,
  removeWaypoint,
  getDistanceTraveled,
  getWaypointNumber,
  getLandingPoint
} from '../waypoint-utilities';

/**
 * Takes in the new landing point and updates the waypoint list.
 *
 * @async
 * @callback
 * @param {*} arg - The object argument.
 * @param {object} arg.myLandingPoint - The new landing point selected by the user.
 * @param {Function} arg.startElevationProgressBar - A function that tells the ui that the elevation data is loading.
 * @param {Function} arg.cancelElevationProgress - A function that tells the ui that the elevation data is not loading anymore.
 * @param {object} arg.mission - The mission object.
 */
const updateLandingInWaypointList = async ({
  myLandingPoint,
  mission,
  startElevationProgressBar,
  cancelElevationProgress
}) => {
  const waypointList = getWaypointList(mission);
  if (!isEmpty(waypointList)) {
    const newLandingPoint = cloneDeep(myLandingPoint);
    const landingPointNumber = getWaypointNumber(getLandingPoint(waypointList));
    newLandingPoint.properties.totalNumber = landingPointNumber;
    const removeOldLanding = removeWaypoint(waypointList, landingPointNumber);
    const addNewLanding = insertNewWaypointsAtIndex(
      removeOldLanding,
      landingPointNumber,
      newLandingPoint
    );
    const estimatedNumberOfPoints = getDistanceTraveled(addNewLanding) / 30;
    startElevationProgressBar(estimatedNumberOfPoints);
    try {
      await saveChangesInRPAPath(mission, addNewLanding);
    } catch (error) {
      cancelElevationProgress();
      throw error;
    }
  }
};

export default updateLandingInWaypointList;
